import { ActionType } from "../../actions/ActionType";
import { Action } from "../../actions/event/eventReportActions";

interface EventReportState {
  isLoading: boolean;
  error: string | null;
  eventTypes: {
    activityType: string;
    activityTypeDescription: string;
  }[];
  eventAreas: {
    activityAreaNumber: string;
    activityAreaDescription: string;
  }[];
  reportTypes: {
    activityReportType: number;
    activityReportTypeDescription: string;
  }[];
  regMethods: {
    activityRegistrationMethod: string;
    activityRegistrationMethodDescription: string;
  }[];
}

const initialState = {
  isLoading: false,
  error: null,
  eventTypes: [],
  eventAreas: [],
  reportTypes: [],
  regMethods: [],
};

const eventReportReducer = (
  state: EventReportState = initialState,
  action: Action
) => {
  switch (action.type) {
    case ActionType.FETCH_EVENT_TYPE_START:
      return {
        isLoading: true,
        error: null,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.FETCH_EVENT_TYPE_SUCCESS:
      return {
        isLoading: false,
        error: null,
        eventTypes: action.payload,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.FETCH_EVENT_TYPE_ERROR:
      return {
        isLoading: false,
        error: action.payload,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.FETCH_EVENT_REPORT_AREAS_START:
      return {
        isLoading: true,
        error: null,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.FETCH_EVENT_REPORT_AREAS_SUCCESS:
      return {
        isLoading: false,
        error: null,
        eventTypes: state.eventTypes,
        eventAreas: action.payload,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.FETCH_EVENT_REPORT_AREAS_ERROR:
      return {
        isLoading: false,
        error: action.payload,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.DL_EVENT_REPORT_START:
      return {
        isLoading: true,
        error: null,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.DL_EVENT_REPORT_SUCCESS:
      return {
        isLoading: false,
        error: null,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.DL_EVENT_REPORT_ERROR:
      return {
        isLoading: false,
        error: action.payload,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.FETCH_REPORT_TYPE_START:
      return {
        isLoading: true,
        error: null,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.FETCH_REPORT_TYPE_SUCCESS:
      return {
        isLoading: false,
        error: null,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: action.payload,
        regMethods: state.regMethods,
      };
    case ActionType.FETCH_REPORT_TYPE_ERROR:
      return {
        isLoading: false,
        error: action.payload,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.FETCH_REG_METHOD_START:
      return {
        isLoading: true,
        error: null,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.FETCH_REG_METHOD_SUCCESS:
      return {
        isLoading: false,
        error: null,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: action.payload,
      };
    case ActionType.FETCH_REG_METHOD_ERROR:
      return {
        isLoading: false,
        error: action.payload,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.DL_EVENT_INFO_REPORT_START:
      return {
        isLoading: true,
        error: null,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.DL_EVENT_INFO_REPORT_SUCCESS:
      return {
        isLoading: false,
        error: null,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    case ActionType.DL_EVENT_INFO_REPORT_ERROR:
      return {
        isLoading: false,
        error: action.payload,
        eventTypes: state.eventTypes,
        eventAreas: state.eventAreas,
        reportTypes: state.reportTypes,
        regMethods: state.regMethods,
      };
    default:
      return state;
  }
};

export default eventReportReducer;
